// modal.js
document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('LoginModal');
  if (!modal) return;

  // open triggers: any element with .open-login-modal class
  document.querySelectorAll('.open-login-modal').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      // optional: trap focus or focus the first input
      var input = modal.querySelector('.phone-input');
      if (input) input.focus();
    });
  });

  // close button(s)
  modal.querySelectorAll('.modal__close').forEach(function(btn){
    btn.addEventListener('click', function(){
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
    });
  });

  // close clicking outside the content
  modal.addEventListener('click', function(e){
    if (e.target === modal) {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
    }
  });

  // basic phone form handling (replace with your OTP API)
  var form = modal.querySelector('.modal__form');
  if (form) {
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var phone = form.querySelector('.phone-input').value || '';
      var numeric = phone.replace(/\D/g,'');
      if (numeric.length < 7) {
        alert('Please enter a valid phone number.');
        return;
      }
      // TODO: call your backend/OTP service here (AJAX or form post)
      // Example placeholder behaviour:
      alert('OTP sent to: +' + numeric);
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
    });
  }
});
